import { render } from "./stars.vue?vue&type=template&id=04cc4d7f&scoped=true&ts=true"
import script from "./stars.vue?vue&type=script&lang=ts"
export * from "./stars.vue?vue&type=script&lang=ts"

import "./stars.vue?vue&type=style&index=0&id=04cc4d7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cc4d7f"]])

export default __exports__